import React from "react";
import SDP from "../animation/branding/Artist Hand.json";
import CST from "../animation/branding/Job Portfolio.json";
import DDD from "../animation/branding/Creative Vision.json";
import ATE from "../animation/branding/Editing Tool.json";
import CE from "../animation/branding/Email Editing.json";
import CBE from "../animation/branding/Mirror Tool.json";
import Lottie from "lottie-react";

const TailorMadeCard = ({ data }) => (
  <div className="relative space-y-2 w-full text-center">
    <div className=" rounded-full flex items-center justify-center ">
      <Lottie
        animationData={data.src}
        loop={true}
        autoplay={true}
        style={{ width: 100 }}
        // className={marginClass}
      />
    </div>
    <div className="text-xl font-bold dark:text-white ">{data.heading}</div>
    <p className="dark:text-gray-300 text-zinc-800 w-[100%] text-md">
      {data.p}
    </p>
  </div>
);

const data = [
  {
    src: SDP,
    heading: "Clarity and Recognition",
    p: "A consistent corporate design can really make or break your brand while making it  recognizable and memorable. It strengthens your visual identity and also builds a long lasting presence that people can actually trust.",
  },
  {
    src: CST,
    heading: "Professional Appearance",
    p: "A really well thought out design reflects competence, reliability and quality earning the trust of both customers and partners.",
  },
  {
    src: DDD,
    heading: "Strong brand identity",
    p: "No guesswork here. Agencies use analytics, insights, and performance metrics to ensure campaigns are efficient and outcomes are measurable—very Bezos-like in precision.",
  },
  {
    src: ATE,
    heading: "Emotional bond",
    p: "An appealing design appeals to the target group emotionally and creates a close connection to the brand.",
  },
  {
    src: CE,
    heading: "Efficient communication",
    p: "A well-thought-out design ensures clear, effective messages and makes them easy to implement across all channels.",
  },
  {
    src: CBE,
    heading: "Differentiation and trust",
    p: "A strong design is the key to standing out from the competition, encouraging employee identification and achieving greater customer loyalty.",
  },
];

const BrandingExtraSection1 = () => {
  return (
    <div className="w-full xl:px-35 px-10 py-25 pb-10 dark:bg-zinc-900 bg-white space-y-10">
      <div className="space-y-7">
        <h1 className="xl:text-5xl text-4xl font-bold mt-2 tracking-tighter text-center dark:text-white">
          The Benefits Of A Powerful Corporate Design
        </h1>

        <h3 className="dark:text-gray-300 text-zinc-800 text-center text-md">
          A strong corporate design can only be built by recognition, trust and
          consistency while reflecting your brand values. It truly strengthens
          your 
          <br className="hidden xl:block" /> {" "}
          reputation, drives engagement, while also making your brand stand out
          by impactful visuals, content and storytelling.
        </h3>
      </div>

      <div className="w-[100%] grid xl:grid-cols-3 md:grid-cols-2 items-center  gap-10">
        {data.map((item, index) => (
          <>
            <TailorMadeCard data={item} />
          </>
        ))}
      </div>
    </div>
  );
};

export default BrandingExtraSection1;
